/* Kaybee showcase product page — behaviour. Ported from the PDP lab (~/kaybee-pdp-lab).
   The page is server-rendered; this adds what Liquid can't easily do: spec chips, key
   features and the short lead from the title/description, the In-the-box tab, thumbnails,
   the round Add-to-cart, the sticky bar, tabs and Recently viewed. */
(() => {
  const root = document.querySelector('[data-kbp]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => Array.from(root.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const data = JSON.parse($('[data-kbp-json]').textContent);

  function readSpecs(p) {
    const t = p.title;
    const specs = [];
    const add = (label, value, icon) => { if (value && !specs.some((s) => s.label === label)) specs.push({ label, value, icon }); };
    let m;
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:RU|U)\b(?:\s*RMS)?/i))) add('Rack units', m[1] + 'U', 'rack');
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:"|”|in\.?|inch)\s*(?:Depth|Deep)/i))) add('Depth', m[1] + '"', 'ruler');
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:"|”|-inch| inch)(?!\s*(?:Depth|Deep))/i)) && !/depth/i.test(m[0])) add('Size', m[1] + '"', 'ruler');
    if ((m = t.match(/\b(\d+(?:\.\d+)?)\s*MP\b/i))) add('Resolution', m[1] + ' MP', 'camera');
    if (/\b4K\b/i.test(t) && !specs.some((s) => s.label === 'Resolution')) add('Resolution', '4K', 'camera');
    if ((m = t.match(/(\d+(?:\.\d+)?(?:\s*[-–]\s*\d+(?:\.\d+)?)?)\s*mm\b/i))) add('Lens', m[1].replace(/\s/g, '') + ' mm', 'lens');
    if ((m = t.match(/\b(\d+)[-\s]?Channel/i))) add('Channels', m[1], 'grid');
    if ((m = t.match(/\b(\d+)[-\s]?Port/i))) add('Ports', m[1], 'ports');
    if ((m = t.match(/\bPoE\+{0,2}/i))) add('Power over Ethernet', m[0].toUpperCase().replace('POE', 'PoE'), 'bolt');
    if ((m = t.match(/\b(\d+(?:\.\d+)?)\s*TB\b/i))) add('Storage', m[1] + ' TB', 'disk');
    if ((m = t.match(/\b(\d+(?:\.\d+)?)\s*W\b/))) add('Power', m[1] + ' W', 'bolt');
    if ((m = t.match(/\b(\d+(?:\/\d+)?)\s*V(?:DC|AC)?\b/))) add('Voltage', m[0], 'bolt');
    if ((m = t.match(/\b(\d+\/\d+)(?=\s|-|$)/)) && /cable|wire|awg|stranded|solid/i.test(t)) add('Gauge / conductors', m[1], 'cable');
    if ((m = t.match(/(\d[\d,]*)\s*(?:'|’|ft\b|feet)/i))) add('Length', m[1] + ' ft', 'ruler');
    if ((m = t.match(/Wi-?Fi\s*(7|6E|6|5)/i))) add('Wi-Fi', 'Wi-Fi ' + m[1].toUpperCase(), 'wifi');
    if ((m = t.match(/\bIP6[5-9]\b/i))) add('Weather rating', m[0].toUpperCase(), 'shield');
    if ((m = t.match(/\bIK1[0-9]\b/i))) add('Impact rating', m[0].toUpperCase(), 'shield');
    if (/\boutdoor\b/i.test(t)) add('Environment', /indoor/i.test(t) ? 'Indoor / outdoor' : 'Outdoor', 'sun');
    else if (/\bindoor\b/i.test(t)) add('Environment', 'Indoor', 'sun');
    if ((m = t.match(/\b(White|Black|Gray|Grey|Ivory|Silver|Bronze|Almond|Beige|Brown|Red|Blue|Yellow|Green|Snow|Charcoal)\b/i))) add('Color', m[1][0].toUpperCase() + m[1].slice(1).toLowerCase(), 'palette');
    return specs;
  }
  
  function readBadges(p, text) {
    const hay = p.title + ' ' + text;
    const out = [];
    [[/\bTAA\b/i, 'TAA compliant'], [/\bNDAA\b/i, 'NDAA compliant'], [/\bUL[- ]?(?:Listed|\d{3,})/i, 'UL listed'],
     [/\bPlenum\b|\bCMP\b|\bFT6\b/i, 'Plenum rated'], [/\bRiser\b|\bCMR\b|\bFT4\b/i, 'Riser rated'], [/\bZ-?Wave\b/i, 'Z-Wave'], [/\bMatter\b/, 'Matter']]
      .forEach(([re, label]) => { if (re.test(hay) && !out.includes(label)) out.push(label); });
    return out;
  }
  
  function readDescription(html) {
    const div = document.createElement('div');
    // line breaks between block elements so separate lines never run together
    div.innerHTML = (html || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h[1-6]|tr|ul|ol|table|section)>/gi, '</$1>\n\n');
    div.querySelectorAll('script,style').forEach((n) => n.remove());
    // supplier-only lines (distributor part numbers) never reach customers
    const internal = (t) => /^ADI (Part|Item)\b/i.test(t);
    const listItems = [...div.querySelectorAll('li')].map((li) => li.textContent.trim()).filter((t) => t && !internal(t));
    div.querySelectorAll('ul,ol').forEach((l) => l.remove()); // bullets are shown as bullets, not repeated as paragraphs
    const raw = div.textContent.replace(/\r/g, '');
    const paras = raw.split(/\n\s*\n|\n(?=[A-Z][^\n]{0,40}:\s)/).map((s) => s.replace(/\s+/g, ' ').trim()).filter((s) => s.length > 1);
    const includes = [];
    const kv = [];
    const body = [];
    paras.forEach((para) => {
      let m;
      if ((m = para.match(/^(?:Includes|In the box|Package contents|What's included)\s*:\s*(.+)$/i))) includes.push(...m[1].split(/;|,(?![^(]*\))/).map((s) => s.trim()).filter(Boolean));
      else if ((m = para.match(/^([A-Z][A-Za-z /&()-]{1,32}):\s*(.{1,80})$/)) && !/\.\s/.test(m[2])) kv.push({ label: m[1], value: m[2] });
      else if (!/^(product overview|overview|specifications?)$/i.test(para)) body.push(para);
    });
    return { paragraphs: body, bullets: listItems, includes, kv, text: raw };
  }
  
  /* ---------- enrich the copy from the product's own data ---------- */
  const descEl = $('[data-kbp-desc]');
  const d = readDescription(descEl ? descEl.innerHTML : '');
  const specs = readSpecs({ title: data.title });
  const badges = readBadges({ title: data.title }, d.text);

  // hide supplier-only lines that are already in the server-rendered description
  if (descEl) descEl.querySelectorAll('li, p').forEach((n) => { if (/^\s*ADI (Part|Item)\b/i.test(n.textContent)) n.remove(); });

  const chips = [...specs.slice(0, 3).map((s) => (/^[\d.]+$/.test(s.value) ? `${s.value} ${s.label.toLowerCase()}` : s.value)), ...badges.slice(0, 1)];
  const chipsEl = $('[data-kbp-chips]');
  if (chips.length && chipsEl) { chipsEl.innerHTML = chips.map((c) => `<span>${esc(c)}</span>`).join(''); chipsEl.hidden = false; }

  const leadEl = $('[data-kbp-lead]');
  let lead = d.paragraphs[0] || '';
  if (lead.length > 260) { const cut = lead.slice(0, 260); const dot = cut.lastIndexOf('. '); lead = dot > 120 ? cut.slice(0, dot + 1) : cut.replace(/\s+\S*$/, '') + '…'; }
  if (lead && leadEl) { leadEl.textContent = lead; leadEl.hidden = false; }

  const keys = (d.bullets.length ? d.bullets : specs.map((x) => `${x.label}: ${x.value}`)).slice(0, 4);
  const keysWrap = $('[data-kbp-keys]');
  if (keys.length && keysWrap) { keysWrap.querySelector('ul').innerHTML = keys.map((k) => `<li>${esc(k)}</li>`).join(''); keysWrap.hidden = false; }

  const badgesEl = $('[data-kbp-badges]');
  if (badges.length && badgesEl) { badgesEl.innerHTML = badges.map((b) => `<span>${esc(b)}</span>`).join(''); badgesEl.hidden = false; }

  const spec = $('[data-kbp-spec]');
  if (spec) {
    const have = new Set($$('[data-kbp-spec] th').map((th) => th.textContent.trim().toLowerCase()));
    const rows = [...specs.map((s) => ({ label: s.label, value: s.value })), ...d.kv.filter((r) => !/^ADI\b/i.test(r.label)), ...(badges.length ? [{ label: 'Compliance & ratings', value: badges.join(' · ') }] : [])];
    rows.forEach((r) => { if (have.has(r.label.toLowerCase())) return; have.add(r.label.toLowerCase()); spec.insertAdjacentHTML('beforeend', `<tr><th>${esc(r.label)}</th><td>${esc(r.value)}</td></tr>`); });
  }

  if (d.includes.length) {
    $('[data-kbp-box]').innerHTML = d.includes.map((b) => `<li>${esc(b)}</li>`).join('');
    $('[data-kbp-tab="box"]').hidden = false;
  }

  /* ---------- tabs ---------- */
  $$('[data-kbp-tab]').forEach((t) => t.addEventListener('click', () => {
    $$('[data-kbp-tab]').forEach((x) => x.classList.toggle('is-on', x === t));
    $$('[data-kbp-panel]').forEach((x) => x.classList.toggle('is-on', x.dataset.kbpPanel === t.dataset.kbpTab));
  }));

  /* ---------- gallery: first photo = cut-out on the stage, others as photo cards ---------- */
  const main = $('[data-kbp-main]');
  const frame = $('.kbp-frame');
  const PLASTER = { stage: 'studio', img: frame ? frame.style.getPropertyValue('--kbp-stage').replace(/kb-stage-\w+\.webp/, 'kb-stage-studio.webp') : '', floor: '0.72' };
  const home = frame ? { stage: frame.dataset.stage, img: frame.style.getPropertyValue('--kbp-stage'), floor: frame.style.getPropertyValue('--kbp-floor') } : null;
  const setStage = (s) => { if (!frame || !s) return; frame.dataset.stage = s.stage; frame.style.setProperty('--kbp-stage', s.img); frame.style.setProperty('--kbp-floor', s.floor); };
  const count = $('[data-kbp-count]');
  const thumbs = $$('[data-kbp-thumb]');
  let cur = 0;
  const show = (i) => {
    if (!main || !thumbs.length) return;
    cur = (i + thumbs.length) % thumbs.length;
    const cut = cur === 0 ? main.dataset.cut : '';
    main.removeAttribute('srcset');
    main.src = cut || thumbs[cur].dataset.full;
    main.classList.toggle('is-cut', !!cut);
    setStage(cut ? home : PLASTER); // plain photos (white background) sit on the white studio stage
    thumbs.forEach((t, k) => t.classList.toggle('is-on', k === cur));
    if (count) count.textContent = `${cur + 1} / ${thumbs.length}`;
  };
  thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
  const stage = $('.kbp-stage');
  let x0 = null;
  if (stage) {
    stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
  }

  /* ---------- variant select ---------- */
  const form = $('[data-kbp-form]');
  const variantSel = $('[data-kbp-variant]');
  const addBtns = $$('[data-kbp-add]');
  if (variantSel) variantSel.addEventListener('change', () => {
    const o = variantSel.selectedOptions[0];
    const ok = o.dataset.available === 'true';
    $$('[data-kbp-price], [data-kbp-price-sticky]').forEach((el) => { el.textContent = o.dataset.price; });
    const cmp = $('[data-kbp-compare]'); if (cmp) { cmp.hidden = !o.dataset.compare; cmp.textContent = o.dataset.compare || ''; }
    const st = $('[data-kbp-stock]');
    if (st) { st.classList.toggle('is-out', !ok); st.lastChild.textContent = ok ? 'In stock — ready to ship' : 'Out of stock — ask us about lead time'; }
    addBtns.forEach((b) => { b.disabled = !ok; const l = b.querySelector('[data-kbp-add-label]') || b; l.textContent = ok ? 'Add to cart' : 'Sold out'; });
  });

  /* ---------- round + sticky Add to cart submit the real product form (the cart drawer catches it) ---------- */
  addBtns.forEach((b) => b.addEventListener('click', () => {
    if (!form || b.disabled) return;
    b.classList.add('is-busy');
    setTimeout(() => b.classList.remove('is-busy'), 1200);
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
  }));

  /* ---------- sticky bar once the round button scrolls away ---------- */
  const sticky = $('[data-kbp-sticky]');
  const dot = $('.kbp-cartdot');
  if (sticky && dot && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', String(!on));
    }).observe(dot);
  }

  /* ---------- recently viewed ---------- */
  try {
    const key = 'kb_recent';
    let rec = [];
    try { rec = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    const shown = rec.filter((x) => x.handle !== data.handle).slice(0, 10);
    const box = $('[data-kbp-recent]');
    if (shown.length && box) {
      const money = (c) => '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      box.querySelector('.kbp-rail__track').innerHTML = shown.map((x) => `<a class="kbp-mini" href="${esc(x.url)}"><span class="kbp-mini__img">${x.image ? `<img src="${esc(x.image)}" alt="" loading="lazy">` : ''}</span><span class="kbp-mini__info"><span class="kbp-mini__brand">${esc(x.vendor)}</span><span class="kbp-mini__title">${esc(x.title)}</span><span class="kbp-mini__price">${money(x.price)}</span></span></a>`).join('');
      box.hidden = false;
    }
    rec = [{ handle: data.handle, url: data.url, title: data.title, vendor: data.vendor, image: data.image, price: data.price }, ...rec.filter((x) => x.handle !== data.handle && x.url)].slice(0, 12);
    try { localStorage.setItem(key, JSON.stringify(rec)); } catch (e) {}
  } catch (e) {}
})();
